import { render, staticRenderFns } from "./WidgetGridContainer.vue?vue&type=template&id=dc60450a&scoped=true"
import script from "./WidgetGridContainer.vue?vue&type=script&lang=ts"
export * from "./WidgetGridContainer.vue?vue&type=script&lang=ts"
import style0 from "./WidgetGridContainer.vue?vue&type=style&index=0&id=dc60450a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc60450a",
  null
  
)

export default component.exports